import heroImage from "../images/hero.jpg";

function Hero() {
  return (
    <section
      id="home"
      className="hero-photo"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "50%",
        position: "relative",
        overflow: "hidden",
        boxShadow: "0 6px 20px rgba(0,0,0,0.5)",
        border: "2px solid black",
      }}
    >
      {/* 🔳 DARK OVERLAY FOR READABILITY */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.35)"
        }}
      />

      {/* 🎭 CENTERED CONTENT */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "white",
          padding: "20px"
        }}
      >
        <h2 style={{ margin: 0, fontSize: "28px", letterSpacing: "1px" }}>
          Director • Actor • Educator
        </h2>

        <p style={{ marginTop: "10px", fontSize: "16px", opacity: 0.9 }}>
          Bringing stories to life on stage and in the classroom
        </p>
      </div>
    </section>
  );
}

export default Hero;